<template>
  <div class="container">
    <el-header>
      <h1>家政管理端</h1>
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          {{ userinfo.login }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="out">退出账号</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>
    <div class="main-container">
      <el-aside width="200px">
        <el-menu class="el-menu-vertical-demo" :default-active="$route.path" router>
          <el-menu-item index="/user"><i class="el-icon-user-solid"></i>用户列表</el-menu-item>
          <el-menu-item index="/master"><i class="el-icon-s-custom"></i>师傅管理</el-menu-item>
          <el-menu-item index="/service"><i class="el-icon-s-order"></i>订单列表</el-menu-item>
          <el-submenu index="0">
            <template slot="title">
              <i class="el-icon-brush"></i>
              <span>服务管理</span>
            </template>
            <el-menu-item-group>
              <!-- <el-menu-item index="/service">服务列表</el-menu-item> -->
              <el-menu-item index="/serviceCategory">服务分类</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-upload2"></i>
              <span>置顶记录</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/topRecord">消费记录</el-menu-item>
            </el-menu-item-group>
          </el-submenu> -->
          <el-menu-item index="/topRecord"><i class="el-icon-upload2"></i>置顶记录</el-menu-item>
          <el-menu-item index="/appIntro"><i class="el-icon-info"></i>应用详情</el-menu-item>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span>会员设置</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/memberSetting">开通会员设置</el-menu-item>
              <el-menu-item index="/memberRecord">师傅充值记录</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-star-on"></i>
              <span>积分设置</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/pointsSetting">积分设置</el-menu-item>
              <el-menu-item index="/pointsRecord">充值记录</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="/purchaseRecord"><i class="el-icon-s-order"></i>购买记录</el-menu-item>
          <!-- <el-menu-item index="/system"><i class="el-icon-s-order"></i>系统管理</el-menu-item> -->
          <el-submenu index="4">
            <template slot="title">
              <i class="el-icon-s-tools"></i>
              <span>系统管理</span>
            </template>
            <el-menu-item-group>
              <!-- <el-menu-item index="/admin">管理员列表</el-menu-item> -->
              <el-menu-item index="/region">地区管理</el-menu-item>
              <el-menu-item index="/project">字典参数</el-menu-item>
              <el-menu-item index="/configure">置顶配置</el-menu-item>
              <el-menu-item index="/pointsAllocationts">积分配置</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main>
        <keep-alive>
          <div style="background-color: white">
            <router-view />
          </div>

        </keep-alive>
      </el-main>
    </div>
  </div>
</template>

<script>
// import tabComponet from '@/components/tabComponets.vue';
import { outLogin } from '@/api/login/login';
export default {
  name: 'HomeView',
  components: {
    // tabComponet
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit('addTab', { name: to.name, title: to.meta.title });
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('removeTab', from.name);
    next();
  },
  data: function () {
    return {
      userinfo: {},
      ruleList: []
    }
  },
  mounted() {
    //document.querySelector('.container').style.height = document.documentElement.clientHeight + 'px';
    if (localStorage.getItem('userInfo')) {
      this.userinfo = JSON.parse(localStorage.getItem('userInfo'))
      this.ruleList = JSON.parse(localStorage.getItem('rule'))
    }
  },
  methods: {
    handleCommand(command) {
      this.$confirm('确定退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let token = localStorage.getItem('token')
        console.log(token);
        if (!token) {
          console.log(22);
          localStorage.removeItem('token')
          this.$router.push('/login')
          console.log(11);
          return
        }
        outLogin().then(res => {
          if (res.state == '200') {
            this.$message({
              message: '退出登录成功！',
              type: 'success'
            });
            // sessionStorage.removeItem('menu')
            localStorage.removeItem('token')
            sessionStorage.removeItem('userInfo')
            this.$router.push('/login')
          }
        })
      }).catch(() => { });
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  /* overflow-y: auto; */
  overflow: hidden;
  height: 100vh;
}

.el-header {
  color: #fff;
  text-align: center;
  background: #0174f8;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-aside {
  color: #333;
  height: 100%;
  padding: 0;
  overflow-y: auto;
  overflow-x: hidden;
  /* position: absolute;
  top: 0;
  bottom: 0; */
}
.el-menu-vertical-demo{
  height: 100%;
}
.el-main {
  flex: 1;
  max-height: 100%;
  overflow-y: auto;
  color: #333;
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.main-container{
  flex: 1;
  display: flex;
  /* height: 200px; */
  overflow: hidden;
}
</style>
